module.exports = __webpack_public_path__ + "img/project-8.b57c0a56.jpg";